import { useEffect, useState } from 'react'
import { AlertQuery, PrometheusAlert } from '../types'
import { getAlerts } from '../services/alertService'
import axios from 'axios'

export interface AlertsState {
  alerts: PrometheusAlert[]
  loading: boolean
  error: unknown | undefined
}

export default function useLoadingAlerts(query?: AlertQuery): AlertsState {
  const [alerts, setAlerts] = useState<PrometheusAlert[]>([])

  const [loading, setLoading] = useState<boolean>(true)

  const [error, setError] = useState<unknown>()

  async function loadAlerts(query?: AlertQuery, signal?: AbortSignal) {
    try {
      setLoading(true)
      setError(undefined)
      setAlerts(await getAlerts(query, { signal }))
    } catch (error) {
      if (!axios.isCancel(error)) {
        console.error(error)
        setError(error)
      }
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    const controller = new AbortController()

    loadAlerts(query, controller.signal)

    return () => {
      setAlerts([])
      controller.abort()
    }
  }, [query?.device, query?.ruuvitag])

  useEffect(() => {
    const controller = new AbortController()

    const ONE_MINUTE = 1000 * 60
    const interval = setInterval(() => {
      loadAlerts(query, controller.signal)
    }, ONE_MINUTE)

    return () => {
      controller.abort()
      clearInterval(interval)
    }
  }, [query?.device, query?.ruuvitag])

  return {
    alerts,
    loading,
    error
  }
}
